export const roleLabel = (r) => {
  if (r === "owner") return "Owner";
  if (r === "admin") return "Owner"; // legacy label
  if (r === "installation_manager") return "Installation Manager";
  if (r === "assistant_installation_manager") return "Assistant Installation Manager";
  if (r === "sales_representative") return "Sales Representative";
  if (r === "warehouse_staff") return "Warehouse Staff";
  if (r === "receptionist") return "Receptionist";
  return r || "";
};

export const statusMeta = (s, archived) => {
  if (archived) return { label: "Archived", cls: "bg-slate-200 text-slate-700" };
  if (s === "active") return { label: "Active", cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" };
  if (s === "upcoming") return { label: "Upcoming", cls: "bg-amber-100 text-amber-900 border border-amber-200" };
  if (s === "completed") return { label: "Completed", cls: "bg-blue-100 text-blue-800 border border-blue-200" };
  return { label: s, cls: "bg-slate-100 text-slate-700" };
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch {
    return iso;
  }
};
